import { useConfigService } from '@thd-nucleus/experience-context';

export const IDME_FLAG_KEY = 'ENABLE_MILITARY_VERIFICATION_IDME';

/* Which vendor is live, for the four places that render off the answer.
/*
/* The switch has three states, not two: `undefined` until the config service
/* answers, then `true` or `false`. Collapsed into `false` with `!!`, the window
/* before the answer arrives is indistinguishable from the kill switch being
/* thrown, and a customer with an unfinished previous application is handed the
/* retired vendor's screen - and its CDN script - for as long as that takes.
/* That is the failure this switch exists to prevent, so only an explicit
/* `false` reaches the retired screen. It is also the right answer if the key
/* never arrives at all - an outage, or the key retired after rollout - because
/* ID.me is the live vendor and the retired screen is the exception.
/*
/* Read through here everywhere rather than at each site, so the page and the
/* sections inside it cannot disagree about which vendor is live: a page that
/* thought ID.me was on while the section inside it thought otherwise would
/* render the previous vendor's button on a page that refuses to act on it. */
export const useIdmeEnabled = () => useConfigService(IDME_FLAG_KEY) !== false;
